module.exports = __webpack_public_path__ + "static/media/item-1.130cb4a2.png";